import { ServiceContainerDto } from "@apiModels/ServiceContainerDto.csharp";
import { TreatmentsContainerDto } from "@apiModels/TreatmentsContainerDto.csharp";

export const treatmentInitialState:
  | TreatmentsContainerDto
  | ServiceContainerDto = {
  bookingName: "",
  description: "",
  type: 0,
  containerId: "",
  stepHeading: "",
  icon: "",
  isSpecialization: false,
  hideInDoctorBooking: false,
  ungroupInDoctorBooking: false,
  isTopLevelFallback: false,
  items: [],
};
